import { Eye } from "lucide-react";
import React, { useCallback, useEffect } from "react";
import Table, { Column } from "../../../components/ui/dashboard/Table";
import { formatCurrency, formatDate } from "../../../lib/utils";
import {
  Vehicle,
  VehicleSearchRequest,
  VehicleSearchResponse,
} from "../../vehicle/@types";
import { useGetPartnerVehiclesMutation } from "../../vehicle/vehicleApiSlice";

const PartnerFinanceTable: React.FC = () => {
  // RTK Query mutation
  const [getFinance, { data: vehicleData, isLoading }] =
    useGetPartnerVehiclesMutation();

  const fetchFinance = useCallback(async () => {
    const requestBody: VehicleSearchRequest = {
      pageNumber: 0,
      pageSize: 100,
    };

    try {
      await getFinance(requestBody).unwrap();
    } catch (err) {
      console.error("Failed to fetch finance:", err);
    }
  }, [getFinance]);

  // Fetch finance on component mount and when filters change
  useEffect(() => {
    fetchFinance();
  }, [fetchFinance]);

  // Table columns configuration
  const columns: Column<Vehicle>[] = [
    {
      key: "payoutId",
      header: "Payout ID",
      width: "20",
      render: (value: string) => <span className="text-hColor">{value}</span>,
    },
    {
      key: "amount",
      header: "Amount",
      width: "24",
      render: (value: number) => (
        <span className="text-hColor">{formatCurrency(value)}</span>
      ),
    },
    {
      key: "datePaid",
      header: "Date paid",
      width: "20",
      render: (value: string) => (
        <span className="text-hColor">{formatDate(value)}</span>
      ),
    },
    {
      key: "bankName",
      header: "Bank name",
      width: "20",
      render: (value: string) => <span className="text-hColor">{value}</span>,
    },
    {
      key: "bankAccountNumber",
      header: "Bank account number",
      width: "16",
      render: (value: string) => <span className="text-hColor">{value}</span>,
    },
    {
      key: "actions",
      header: "Action",
      width: "12",
      align: "center" as const,
      render: (value: any, item: Vehicle) => (
        <span className="text-primary">
          View <Eye />
        </span>
      ),
    },
  ];

  const response = vehicleData?.data as VehicleSearchResponse | undefined;

  return (
    <div className="">
      <Table
        data={response?.data || []}
        columns={columns}
        loading={isLoading}
        emptyMessage="No finance found"
      />
    </div>
  );
};

export default PartnerFinanceTable;
